import { WebRoutes } from "consts/enpoints/web";
import { Step } from "ui/organizms/ECommerce/Onboarding/common";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingApplication } from "../../hooks";
import { useMarketingWebsiteAndSupport } from "./useMarketingWebsiteAndSupport";

const MarketingWebsiteAndSupport = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const marketingWebsiteAndSupport = useMarketingWebsiteAndSupport();

    return (
        <Step
            title='Marketing, Website and Support'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.HighRiskMerchant}
        >
            <HighRiskMerchant.MarketingWebsiteAndSupport.Form
                {...marketingWebsiteAndSupport}
            />
        </Step>
    );
};

export default MarketingWebsiteAndSupport;
// export default withApplication(MarketingWebsiteAndSupport);
